/** Contenu FR de la home (copie exacte de l'existant — zéro régression). */
import type { LandingData } from "./landingDict";

export const LANDING_FR: LandingData = {
  pageTitle:
    "Location de voiture et chauffeur privé à Cannes | KS Rent Services",
  hero: {
    driverTitle: "Réservation",
    driverDescription:
      "Un service de chauffeur privé haut de gamme pour tous vos déplacements professionnels et personnels",
    driverCta: "Réserver maintenant",
    rentalTitle: "Location",
    rentalDescription:
      "Une flotte de véhicules haut de gamme pour répondre à tous vos besoins de mobilité",
    rentalCta: "Découvrir nos véhicules",
    driverImageAlt: "Service de chauffeur privé KS Rent",
    rentalImageAlt: "Location de véhicules KS Rent",
    scrollHint: "Faites défiler",
  },
  clients: {
    heading: "Ils nous font confiance",
    divider: "Nos clients",
    reviewsHeading: "Avis clients",
    reviews: [
      {
        quote:
          "Service level outstanding. The clients and I had an exceptional time and the customer service was excellent.",
        author: "Karen O. - Directrice mode",
      },
      {
        quote:
          "Flawless coordination, absolute discretion, and perfect punctuality across several confidential journeys.",
        author: "Membre d'une famille royale d'Arabie saoudite",
      },
      {
        quote:
          "A proactive team, immaculate vehicles, and a premium experience from first contact to final drop-off.",
        author: "Responsable partenariats événementiels",
      },
    ],
  },
  about: {
    heading: "Qui sommes nous",
    intro:
      "Depuis 2018 à Cannes, nous accompagnons personnalités, entreprises et voyageurs exigeants sur toute la Côte d’Azur. Notre savoir‑faire: une flotte haut de gamme irréprochable et des chauffeurs triés sur le volet pour une expérience ultra‑personnalisée.",
    cta: "À propos de KS Rent Services",
    items: [
      {
        icon: "mdi:star-outline",
        title: "Excellence du service",
        desc: "Standards 5★, protocole d’accueil et discrétion absolue.",
      },
      {
        icon: "mdi:map-marker-radius-outline",
        title: "Cannes & Riviera",
        desc: "Opérations sur toute la Côte d’Azur: Nice, Monaco, Saint‑Tropez…",
      },
      {
        icon: "mdi:steering",
        title: "Flotte haut de gamme",
        desc: "Véhicules premium entretenus et équipés pour votre confort.",
      },
    ],
  },
  services: {
    eyebrow: "Cannes • Côte d’Azur",
    heading: "Deux expertises, un standard d'excellence",
    intro:
      "Deux façons de vous déplacer. Avec le chauffeur privé, un conducteur professionnel vous conduit dans nos véhicules : vous profitez du trajet, nous gérons la route, l’attente et les bagages. Avec la location, vous prenez vous-même le volant d’un véhicule premium, livré à l’adresse de votre choix.",
    driverTitle: "Chauffeur privé",
    driverBadge: "Service 5★",
    driverLead:
      "À disposition, transferts aéroports/gares, évènements et déplacements d’exception. Discrétion, ponctualité et confort absolu.",
    driverSub:
      "Un service opéré avec conducteur dédié pour vos transferts, événements et mises à disposition.",
    driverItems: [
      "Aéroport & Gares",
      "À disposition",
      "Évènements",
      "Entreprises",
    ],
    driverCitiesLabel: "Par ville",
    driverCities: [
      "Chauffeur privé à Cannes",
      "VTC à Antibes",
      "Chauffeur à Nice",
      "Chauffeur privé à Monaco",
      "Chauffeur à Saint-Tropez",
    ],
    driverCtaPrimary: "Réserver maintenant",
    driverCtaSecondary: "En savoir plus",
    rentalTitle: "Location de véhicules",
    rentalBadge: "Luxe & Prestige",
    rentalLead:
      "Flotte premium, livraison/collecte, assurance adaptée et assistance 24/7. L’expérience luxe, au volant.",
    rentalSub:
      "Des véhicules premium remis pour vos propres trajets, avec un accompagnement sur mesure.",
    rentalItems: [
      "Prestige",
      "SUV & Berlines",
      "Cabriolets",
      "Livraison/Collecte",
    ],
    rentalCtaPrimary: "Découvrir nos véhicules",
    rentalCtaSecondary: "Devis sur mesure",
    note: "Disponible à Cannes et sur toute la Côte d’Azur. Coordination d’évènements, dispositifs multi‑véhicules et exigences spéciales sur demande.",
  },
  gallery: {
    eyebrow: "Notre flotte",
    heading: "Galerie de véhicules",
    intro:
      "Supercars iconiques, berlines d’exception, SUV luxueux et cabriolets. Découvrez une sélection de véhicules disponibles à la location sur toute la Côte d’Azur.",
    bullets: [
      "Rolls Royce & Maybach",
      "Lamborghini & Ferrari",
      "Porsche & Aston Martin",
      "Mercedes & Range Rover",
    ],
    ctaPrimary: "Voir toute la flotte",
    ctaSecondary: "Demande spéciale",
    prevLabel: "Image précédente",
    nextLabel: "Image suivante",
    pauseLabel: "Mettre en pause",
    resumeLabel: "Reprendre le diaporama",
    dotLabel: (n) => `Voir l'image ${n}`,
    carFallbackAlt: "Véhicule",
  },
  excursions: {
    heading: "Nos excursions les plus populaires",
    discover: "Découvrir",
  },
  enterprise: {
    eyebrow: "Accompagnement entreprise",
    heading: "Entreprises & Évènements",
    text: "Besoin d’un dispositif sur‑mesure, d’un coordinateur ou de plusieurs véhicules ? Notre équipe conçoit et opère vos solutions de mobilité clé en main.",
    ctaContact: "Nous contacter",
    ctaReserve: "Réserver un chauffeur",
  },
  valueProps: {
    eyebrow: "Le choix des clients les plus exigeants",
    heading: "La promesse KS Rent Services",
    intro:
      "Des prestations pensées pour les personnalités, les agents et les entreprises: flexibilité, sécurité et excellence de service.",
    reviewsEyebrow: "Avis clients anonymisés",
    googleEyebrow: "Avis Google",
    googleNote: "Excellence confirmée par des profils exigeants.",
    catalogueLabel: "Catalogue",
    modelsAvailable: (n) => `${n}+ modèles disponibles`,
    reviews: [
      {
        quote:
          "Coordination premium sur plusieurs journées, sans friction opérationnelle.",
        source: "Maison de mode (anonymisé)",
        tag: "Coordination",
      },
      {
        quote:
          "Ponctualité constante et exécution irréprochable sur chaque transfert.",
        source: "Direction internationale (anonymisé)",
        tag: "Ponctualité",
      },
      {
        quote:
          "Discrétion totale, qualité véhicule parfaite et équipe très réactive.",
        source: "Profil VIP (anonymisé)",
        tag: "Discrétion",
      },
      {
        quote:
          "Pilotage logistique maîtrisé même avec des contraintes de planning serrées.",
        source: "Agence événementielle (anonymisé)",
        tag: "Logistique",
      },
    ],
    cards: [
      {
        title: "Paiement simplifié",
        description: "CB, virement et corporate. Validation rapide.",
        label: "Paiement",
      },
      {
        title: "Disponibilité 24/7",
        description:
          "Assistance continue, retour rapide et suivi en temps réel.",
        label: "Support",
      },
      {
        title: "Satisfaction 100%",
        description:
          "Retours de marques et profils exigeants, en version anonymisée.",
        label: "Expérience",
      },
      {
        title: "Flotte Prestige",
        description: "Berlines, SUV, cabriolets — des standards élevés.",
        label: "Véhicules",
      },
      {
        title: "Évènementiel",
        description: "Coordination multi‑véhicules & dispositifs VIP.",
        label: "Opérations",
      },
      {
        title: "Discrétion & Sécurité",
        description: "Protocoles stricts, confidentialité totale.",
        label: "Confiance",
      },
    ],
    fleetAlt: "Flotte KS Rent Services",
    eventsAlt: "Ambiance évènementielle",
  },
  universe: {
    heading: "Univers KS Rent Services",
    intro:
      "Chauffeur privé, moments clients et univers flotte : une lecture immédiate de nos standards de service sur la Riviera.",
    brandFilmAlt:
      "Film de marque KS Rent Services avec chauffeur privé et flotte premium",
    socialProofAlt:
      "Mise en situation client et service premium KS Rent Services",
    fleetUniverseAlt: "Univers de flotte premium KS Rent Services",
  },
  orient: {
    heading: "Orienter votre demande",
    links: [
      { label: "Réserver un chauffeur", frPath: "/chauffeur" },
      { label: "Explorer les excursions privées", frPath: "/excursions" },
      {
        label: "Louer un véhicule",
        frPath: "/location/vehicules#catalogue-location",
      },
      { label: "Demande rapide", frPath: "/reservation" },
    ],
  },
};
